import React, { useState, useEffect } from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Cancel from './../../../../../assets/icons/close.png'
import Typography from '@mui/material/Typography'
import AutoCompleteMultiSelect from '../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TimingComponenet from '../../../../components/TimingComponenet/TimingComponenet.tsx';
import plusIcon from './../../../../../assets/icons/plus.png'
import AddMenuDialog from '../../AddMenuDialog.tsx';
import itemImg from './../../../../../assets/icons/recommend.png'
import SchedulerComponent from './../../SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx'


function AddRecommendationDialog(props) {
    const [openMenuDialog, setOpenMenuDialog] = useState(false)

    const handleDialogOpen = (name) => {
        setOpenMenuDialog(true)
    }
    const handleAddItem = (AddSectionData) => {
        // setOpenDialog(AddSectionData)
        setOpenMenuDialog(AddSectionData)
        // setOpenItemDialog(AddSectionData)
    }



    const handleClose = () => {
        props.onHandleAddItem(false)
    }

    const sectionDatasArr = [
        {
            type: "Online",
            datas: [{ id: 1, title: 'Chicken' },
            { id: 2, title: 'Burger' },
            { id: 3, title: 'Curry' },
            { id: 4, title: 'Soup' },
            { id: 5, title: 'Fries' }]
        },
        {
            type: "In-store",
            datas: [{ id: 1, title: 'Chicken' },
            { id: 2, title: 'Burger' },
            { id: 3, title: 'Curry' }]
        },
    ]

    const [sectionDatas, setsectionDatas] = useState([]);
    const menuDatas = [
        { id: 1, title: 'Online' },
        { id: 2, title: 'In-store' },
    ]
    const selectMenuValue = (props) => {
        let obj = sectionDatasArr.find(x => x.type === props);
        setsectionDatas(obj?.datas);
    }
    const addValue = (props) => {
        console.log(props)
        // setAutoCompleteValue(props)
    }
    const [radiovalue, setRadioValue] = React.useState('Specify');
    const [isactive, setIsactive] = React.useState(false);
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadioValue((event.target as HTMLInputElement).value);

    };

    const selectedData = (props) => {
        console.log("P: " + props);

    };

    const [switchCheck, setswitchCheck] = React.useState(false)
    const [selectDay, setSelectDay] = React.useState(true);
    const [mselectDay, setMSelectDay] = React.useState(true);
    const [TselectDay, setTSelectDay] = React.useState(true);
    const [WselectDay, setWSelectDay] = React.useState(true);
    const [T1selectDay, setT1SelectDay] = React.useState(true);
    const [FselectDay, setFSelectDay] = React.useState(true);
    const [SselectDay, setSSelectDay] = React.useState(true);
    const [fromTime, setfromTime] = React.useState();
    const [toTime, settoTime] = React.useState();

    const [timingTableDatas, setTimingTableDatas] = React.useState([]);
    const [temptimingTableDatas, settemptimingTableDatas] = React.useState([]);
    const [dayTableDatas, setdayTableDatas] = React.useState([]);

    const clearDays = () => {
        setSelectDay(true);
        setMSelectDay(true);
        setTSelectDay(true);
        setWSelectDay(true);
        setT1SelectDay(true);
        setFSelectDay(true);
        setSSelectDay(true);
    }

    const assignData = (props) => {
        console.log("Called");
        setTimingTableDatas(() => { return (props) });
    }


    useEffect(() => {
        console.log("Use State called");
        setTimingTableDatas(temptimingTableDatas);
    }, [timingTableDatas]);

    const removeData = (props) => {
        let tempData = temptimingTableDatas;
        let data = tempData.find(x => x.Id === props);
        if (data != undefined) {
            const index = tempData.indexOf(data);
            if (index > -1) { // only splice array when item is found
                tempData.splice(index, 1); // 2nd parameter means remove one item only
            }
        }
        settemptimingTableDatas(tempData)
        setTimingTableDatas([]);
    }

    const setTimeTable = () => {

        var timing = fromTime + "-" + toTime;
        temptimingTableDatas.push({
            Id: temptimingTableDatas.length + 1,
            timing: timing,
            days: dayTableDatas
        });
        setdayTableDatas([]);
        console.log("Timing: " + temptimingTableDatas);
        setTimingTableDatas(temptimingTableDatas);
        clearDays();
    }
    const setDay = (props) => {

        console.log("props: " + props);
        switch (props) {
            case "S":
                dayTableDatas.push({
                    name: "Sunday",
                    ShortName: "S"
                })
                break;
            case "S1":
                dayTableDatas.push({
                    name: "Saturday",
                    ShortName: "S1"
                })
                break;
            case "M":
                dayTableDatas.push({
                    name: "Monday",
                    ShortName: "M"
                })
                break;
            case "T":
                dayTableDatas.push({
                    name: "TuesDay",
                    ShortName: "T"
                })
                break;
            case "W":
                dayTableDatas.push({
                    name: "Wednessday",
                    ShortName: "W"
                })
                break;
            case "T1":
                dayTableDatas.push({
                    name: "Thursday",
                    ShortName: "T1"
                })
                break;
            case "F":
                dayTableDatas.push({
                    name: "Friday",
                    ShortName: "F"
                })
                break;
            default:
                return 'Nothing';
        }
    }

    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={8}>
                            <DialogTitle>
                                <div className='d-flex' style={{ gap: "8px" }}>
                                    <div>
                                        <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                                    </div>

                                    <span style={{ color: "#2a7fd4" }}>GoTaste :-  Add recommended item for Pot Kettle Black Manchester</span>
                                </div>
                            </DialogTitle>
                        </Grid>
                        <Grid item xs={4}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Select Menu
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Select Menu"}
                                    placeholder={'Select Menu'}
                                    value={selectMenuValue}
                                    datas={menuDatas}
                                    id={1}
                                />

                            </Grid>
                            <Grid item xs={1} className="" onClick={() => handleDialogOpen('menu')}>
                                {/* <img src={plusIcon} alt="+" onClick={() => handleDialogOpen('menu')} /> */}
                                <button className='modalAddButton'>+Add Menu</button>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Item Name
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Item Name"}
                                    placeholder={'Item Name'}
                                    value={addValue}
                                    datas={sectionDatas}
                                    id={2}
                                />

                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Timing
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>

                                <SchedulerComponent />
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Is Active
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <Switch
                                    checked={switchCheck}
                                    onChange={() => { setswitchCheck(!switchCheck) }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />

                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <Button className="">Save</Button>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>

            <AddMenuDialog open={openMenuDialog}
                dialogType={'Add Menu'} onHandleAddItem={handleAddItem} />
        </div >
    );
}

export default AddRecommendationDialog;